import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import css from './Mh200H5.module.scss';
import MhA from './mhA';
import MhBH5 from './h5/mhBH5';
import MhC from './mhC';
import MhKh5 from './h5/mhKh5';
import MhEh5 from './h5/mhEh5';
import MhFh5 from './h5/mhFh5';
import MhGh5A from './h5/mhGh5/mhGh5A';
import MhGh5B from './h5/mhGh5/mhGh5B';
import MhGh5C from './h5/mhGh5/mhGh5C';
import MhHh5 from './h5/mhHh5';
import MhIh5 from './h5/mhIh5';
import MhJh5 from './h5/mhJh5';
import MhTextC from './mhTextC';
import MhTextD from './mhTextD';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { LineSpace } from '@/componentsH5/ProductComponents';
import OtherList from '@/components/ProductCommon/OtherList';

export default function Mh200H5({}: any) {
    const { gloproductlist } = useGlobal();
    // if (typeof window == 'undefined') {
    //     return null;
    // }
    // debugger
    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined' && typeof ScrollMagic == 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    const otherProductData = getDetaileMoreProducts(gloproductlist, ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max']);

    return (
        <div className={`Mh200H5 ${css.Mh200H5}`}>
            <MhA />
            <MhBH5 />
            <MhC />
            <MhKh5 />
            <MhEh5 />
            <MhFh5 />
            <MhGh5A />
            <MhGh5B />
            <MhGh5C />
            <MhHh5 />
            <MhIh5 />
            <MhJh5 />
            <MhTextD />
            <MhTextC />
            <LineSpace height={1.2} background="#fff" />
            <OtherList data={otherProductData} />
        </div>
    );
}
